import type { EntityIdAliasPrefixes } from '@abb-procure/constants';
import type { ConnectedPosition } from '@angular/cdk/overlay';

export const TOOLTIP_POSITIONS: ConnectedPosition[] = [
  {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetX: 150,
  },
  {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
  },
];

export const FALLBACK_COLOR = '#adadad';

export const colors: Record<EntityIdAliasPrefixes, string> = {
  PROJ: '#ff6c25',
  RFRFQ: '#00acb6',
  RFQ: '#0096ea',
  QUOT: '#6d1541',
  PEX: '#d90000',
  PE: '#0a8a15',
  TRFRFQ: '#00667a',
  TPROJ: '#991f00',
  CATM: '#000000',
  SUP: '#991f00',
  SUPSTR: '#991f00',
  USER: 'transparent',
  TSPE: '#190482',
  PSPE: '#6D67E4',
  GSPT: '#ff000f',
  SPE: '#b266ff',
  DSESC: '#000000',
  AG: '#000000',
  UNIT: FALLBACK_COLOR,
  LD: FALLBACK_COLOR,
  HUB: FALLBACK_COLOR,
  DIV: FALLBACK_COLOR,
};

export const SEARCH_TAB_TOOLTIPS: Record<string, string> = {
  proj: 'Project',
  rfrfq: 'Request for RFQ',
  rfq: 'Request for Quotation',
  quot: 'Quotation',
  catm: 'Category Management',
  sup: 'Supplier',
  sups: 'Supplier Strategy',
  unit: 'Organisation Unit (Division, Hub, Local Division)',
};

export const MIN_INPUT_LENGTH = 3;
export const DEBOUNCE_MS = 500;

export const PAGE_INDEX = 1;
export const PAGE_SIZE = 15;
export const DEFAULTS_PAGE_INDEX = 0;
export const DEFAULTS_PAGE_SIZE = 15;

export const DEFAULT_MIN_RANGE = 0;
export const DEFAULT_MAX_RANGE = 100;
export const DEFAULT_RANGE_STEP = 1;

export const WILDCARD_SEARCH_TERM = '*';
